<template>
  <ScreenAdapter>
  <div class="drugs flex-column">
    <div class="drugs-top flex-row justify-between">
      <div class="drugs-top-left01 flex-row align-center">
        <img src="../assets/img/logo.png" alt="">
       <!-- <span style="font-weight:600">{{OrgName}}</span>
        <span>|</span> -->
        <span>价格公示</span>
      </div>
      <!-- <div class="drugs-top-right flex-row align-center flex-shrink" id="times">
          {{timeMsg}}
          <img src="../assets/img/set-bl.png" alt="" @click="goSet">
      </div> -->
    </div>
    <div class="drugs-con02 flex-1 flex-row justify-between " >
      <div class="drugs-con-common01 drugs-con-body flex-column">
        <p  class="con-common-name" style="color:#333;">价格公示</p>
        <ul class="flex-row align-center mdicine-common-ti">
          <li>No</li>
          <li>物料名称</li>
          <li>单位</li>
          <li>零售价(元)</li>
          <li>会员价(元)</li>
        </ul>
        <div class="swiper-container flex-column" id="swiperLeft">
          <MedicineList :list="medicineList" types="py" />
        </div>
      </div>
    <!--  <div class="drugs-con-common drugs-con-right flex-column" v-if="DataType == 3 || DataType == 2">
        <p class="con-common-name" style="background: #0d4471;">待取药</p>
        <ul class="con-common-ti flex-row align-center" style="background-color:#146db6">
          <li :style="{'width':DataType==2?'260px':'110px'}">No</li>
          <li :style="{'width':DataType==2?'700px':'320px'}">顾客信息</li>
          <li :style="{'text-align':DataType==2?'center':'right'}">取药码</li>
        </ul>
        <div class="swiper-container flex-column" id="swiperRight">
          <OrderList :list="medicineList" types="qy" :DataType="DataType" />
        </div>
      </div> -->
    </div>
    <!-- <div class="drugs-footer flex-row align-center justify-between">
      <span>温馨提示：请依据队列提示信息，按号取药！祝您早日康复！</span>
      <span>圣者济世·爱心养生</span>
    </div> -->
  </div>
  </ScreenAdapter >
</template>

<script>
import ScreenAdapter from '../components/ScreenAdapter'
import MedicineList from '../components/medicineList'
import Swiper from 'swiper'
import Speech from 'speak-tts'
export default {
  components: {ScreenAdapter, MedicineList},
  data () {
    return {
      timeMsg: '', // 时间
      speech: null, // 浏览器语音播报实例
      audioText: '', // 要播放的语音文字
      OrgCode: '', // 组织id
      OrgName: '', // 组织名称
      DataType: 3, // 区分要查询的内容，1待调剂，2待取药，3待调剂和待取药，默认为3全部配置
      DqySilder: 10, // 待取药默认5个
      CashType: '', // 分类
      adjusteList: [], // 待调剂
      medicineList: [], // 待取药
      audioPlayList: [], // 要播放的语音列表
      audioisPlayList: [], // 已经播放的语音列表
      timer: null, // 当前时间定时器
      getOrderTimer: null, // 获取订单定时器
      voiceEnd: true, // 语音是否播放完毕
      leftDataEnd: true, // 获取左边待调剂是否滚动完毕
      rightDataEnd: true, // 获取右边待取药是否滚动完毕
      audioList: [] // 处理后的播放语音列表
    }
  },
  mounted () {
    // eslint-disable-next-line no-unused-vars
    let parmas = this.$route.query
    // 路由参数中有组织，查询类别，查询种类参数
    if (JSON.stringify(parmas) !== '{}') {
      this.OrgCode = parmas.OrgCode // 组织id
      this.CashType = parmas.CashType // 处方类别
      this.OrgName = parmas.OrgName // 组织名称
    } else {
      let localData = JSON.parse(this.local.getItem('params')) // 获取本地缓存中的配置信息
      if (localData) {
        this.OrgCode = localData.OrgCode
        this.CashType = localData.CashType
        this.OrgName = localData.OrgName
      } else {
        // this.goSet()
      }
    }
    this.getInitData(1)
    this.initTime() // 初始化系统时间
  },
  created () {
    this.medicineList = []
  },
  beforeDestroy () {
    // 页面销毁的时候暂停语音，清除页面所有定时器
    this.audioList.forEach(item => {
      item.pause()
    })
    clearInterval(this.timer)
    clearInterval(this.getOrderTimer)
  },
  methods: {
    // 初始化数据
    getInitData (type) {
      this.$http.post('/BigScreenGood/GetList', {
        PageIndex: 1, // 第几页
        PageSize: 100000, // 一次多少条
        TimeData: 1, //
        OrgCode: ''// 组织id
      }).then(data => {
        console.log('data.data.Take', data.data.Take)
        this.medicineList = data.data.Take || [] // 药品列表
        this.leftDataEnd = this.medicineList.length <= 20 // 当待配药列表数据小于5条，设置轮询标志默认true
        if (type === 1) {
          this.initSwiper()
        }

      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        // alert('网络异常，请检查网络设置!')
      })
    },

    // 跳转设置
    goSet () {
      this.$router.push({
        name: 'set',
        params: {

        }
      })
    },
    // 初始化swiper
    initSwiper () {
      let _this = this
      // eslint-disable-next-line no-unused-vars
      // eslint-disable-next-line eqeqeq

      // eslint-disable-next-line no-unused-vars
      let mySwiperLeft = new Swiper('#swiperLeft', {
        direction: 'vertical', // 垂直切换选项
        // loop: true, // 循环模式选项
        speed: 1500,
        slidesPerView: 20,
        slidesPerGroup: 20,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 5000
        },
        on: {
          init: function () {
            this.slideTo(0, 0) // 切换到第1个slide（索引0），动画时长0ms
          },
          reachBeginning: function () {
            _this.leftDataEnd = false
          }
        }
      })
    },
    // 初始化系统时间
    initTime () {
      this.$http.get('/Sys_Date').then(data => {
        let timeMsg = data.data
        this.timeMsg = this.util.formatDate(data.data * 1000, 'yyyy年MM月dd日 hh:mm:ss')
        this.timer = setInterval(() => {
          timeMsg += 1
          this.timeMsg = this.util.formatDate(timeMsg * 1000, 'yyyy年MM月dd日 hh:mm:ss')
        }, 1000)
      })
    }
  }
}
</script>

<style>
@import url('../assets/css/index.css');
@import url('../assets/css/medicineShow.css');
</style>



// WEBPACK FOOTER //
// src/pages/medicineShow.vue